<!-- @prettier -->
<template>
	<div class="hours-operation__breaks-form" :class="{ open: showBreakForm }">
		<div
			v-if="showBreakForm"
			class="cf-node-properties__hours-filter-breaks-form"
		>
			<div class="hours-operation__field-item">
				<div class="m-r-5">
					<label>Start Time</label>
					<input
						class="form-control hours-operation__time-input"
						v-model="timeBreak.time"
						type="time"
						step="300"
						aria-label="Break Time"
						@change="setStartTime"
					/>
				</div>
			</div>
			<div class="hours-operation__filed">
				<div class="hours-operation__duration">
					<label>Duration (Min)</label>
					<input
						v-model="timeBreak.lengthInMin"
						type="number"
						class="form-control hours-operation__time-input"
						:class="{ invalid: !timeBreak.lengthInMin }"
						aria-label="Duration in Minutes"
					/>
				</div>
			</div>
		</div>
		<div
			class="cf-node-properties__action-buttons hours-operation__action-buttons"
			:class="{ open: showBreakForm }"
		>
			<button
				v-if="!showBreakForm && !disabled"
				type="button"
				class="btn btn-success btn-sm"
				@click="toggleBreakForm"
			>
				<i class="fa fa-plus" />
				<span>Add Break</span>
			</button>
			<template v-if="showBreakForm && !disabled">
				<button
					type="button"
					class="btn btn-success btn-sm m-r-10"
					@click="addBreak"
				>
					Save
				</button>
				<button
					type="button"
					class="btn btn-danger btn-sm"
					@click="toggleBreakForm"
				>
					Cancel
				</button>
			</template>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'HoursOfOperationBreakForm',
	props: {
		index: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			}
		}
	},
	data() {
		return {
			timeBreak: {
				time: '12:00',
				lengthInMin: '45',
				startTime: {
					hour: '12',
					minute: '00'
				}
			},
			showBreakForm: false
		};
	},
	methods: {
		setStartTime() {
			this.timeBreak.startTime = {
				hour: moment(this.timeBreak.time, 'HH:mm').format('HH'),
				minute: moment(this.timeBreak.time, 'HH:mm').format('mm')
			};
		},
		addBreak() {
			if (
				this.timeBreak.lengthInMin &&
				this.timeBreak.startTime.hour &&
				this.timeBreak.startTime.minute
			) {
				const timeBreak = {
					lengthInMin: ~~this.timeBreak.lengthInMin,
					startTime: {
						hour: ~~this.timeBreak.startTime.hour,
						minute: ~~this.timeBreak.startTime.minute
					}
				};
				this.$emit('addBreak', { timeBreak, index: this.index });
				this.toggleBreakForm();
				this.timeBreak = {
					time: '12:00',
					lengthInMin: '45',
					startTime: {
						hour: '12',
						minute: '00'
					}
				};
			}
		},
		toggleBreakForm() {
			this.showBreakForm = !this.showBreakForm;
			this.$emit('toggleBreakForm', this.showBreakForm);
		}
	}
};
</script>
